/* eslint-disable no-sequences */
/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
const projectionTester = (projectionRef) => {
  let visible;
  const stream = projectionRef.stream({ point() { visible = true; } });
  return ([x, y]) => (visible = false, stream.point(x, y), visible);
};
export default projectionTester;
